import { connect } from 'react-redux';
import WixSDK from 'shared/utils/wix-sdk';
import autobind from 'core-decorators/lib/autobind';
import { createSender } from 'shared/bi/bi-with-state-defaults';
import { getCompId } from 'shared/utils/comp-id';

export const BI_EVENT = 'BI_EVENT';
const currentCompId = getCompId();

/*
  ATTENTION:
  This class is designed to use in widget only yet.
  Do not use in overlays (full screen modals) just to have ONLY SINGLE INSTANCE of BiHandler per app.
 */
@connect(store => ({
  sendEvent: createSender(store),
}))
export default class BiHandler extends React.Component {
  static propTypes = {
    sendEvent: React.PropTypes.func,
  };

  static contextTypes = {
    store: React.PropTypes.object,
  };

  componentDidMount() {
    WixSDK.PubSub.subscribe(BI_EVENT, this.sendBiEvent);
  }

  componentWillUnmount() {
    WixSDK.PubSub.unsubscribe(BI_EVENT, this.sendBiEvent);
  }

  @autobind
  sendBiEvent({ data }) {
    const { eventName, params, targetCompId } = data;
    if (targetCompId === currentCompId) {
      this.props.sendEvent(eventName, params);
    }
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/shared/bi/bi-handler.js